import { useQuery } from '@tanstack/react-query';
import { getWeeklyLearningGuideTrackColors } from '../../services/weeklyLearningGuideTrackColorsService';
import { loadWeeklyLearningGuideTrackColorsCache } from '../../utils/weeklyLearningGuideTrackColorsCache';
import { schoolKeys } from '../keys';
import { lsInitialDataOptions } from './lsInitialData';

export type UseWeeklyLearningGuideTrackColorsQueryParams = {
  workspaceId: string;
  academicYear: number;
  gradeId: string;
  enabled?: boolean;
  forceRefresh?: boolean;
};

export function useWeeklyLearningGuideTrackColorsQuery(params: UseWeeklyLearningGuideTrackColorsQueryParams) {
  const { workspaceId, academicYear, gradeId, enabled = true, forceRefresh = false } = params;
  const ls = loadWeeklyLearningGuideTrackColorsCache(workspaceId, academicYear, gradeId);

  return useQuery({
    queryKey: schoolKeys.weeklyLearningGuideTrackColors(workspaceId, academicYear, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(!forceRefresh && ls.found, ls.map),
    queryFn: () => getWeeklyLearningGuideTrackColors(workspaceId, academicYear, gradeId),
  });
}
